export { WalkAlt as default } from './WalkAlt';
